import {
  workorderComplementColor,
  WorkOrderComplementStatus,
} from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';

export interface WorkOrderIndicatorOption {
  key: string;
  label: string;
  color: string;
  colorVariant: string;
}

export const workorderIndicatorOptions: WorkOrderIndicatorOption[] = [
  {
    key: 'totalAmount',
    label: 'Todos os status',
    color: 'default',
    colorVariant: 'rgb(134, 142, 150)',
  },
  {
    key: 'totalOpened',
    label: 'Em aberto',
    color: workorderComplementColor[WorkOrderComplementStatus.Open],
    colorVariant: 'rgb(24, 100, 171)',
  },
  {
    key: 'totalAuthorized',
    label: 'Autorizados',
    color: workorderComplementColor[WorkOrderComplementStatus.Authorized],
    colorVariant: 'rgb(230, 119, 0)',
  },
  {
    key: 'totalClosed',
    label: 'Fechados',
    color: workorderComplementColor[WorkOrderComplementStatus.Closed],
    colorVariant: 'rgb(43, 138, 62)',
  },
  {
    key: 'totalCanceled',
    label: 'Cancelados',
    color: workorderComplementColor[WorkOrderComplementStatus.Cancelled],
    colorVariant: 'rgb(201, 42, 42)',
  },
];

export const workorderIndicatorItensOptions: WorkOrderIndicatorOption[] = [
  {
    key: 'totalParts',
    label: 'Total de peças',
    color: 'default',
    colorVariant: 'rgb(134, 142, 150)',
  },
  {
    key: 'totalServices',
    label: 'Total de serviços',
    color: 'default',
    colorVariant: 'rgb(134, 142, 150)',
  },
];
